import React, { useRef } from 'react';
import { Button, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCC } from '../../contexts/CCContext';
import { cropLabel, isMapPreview } from './publicationContract';

export default function CCPublicationLegend() {
  const cc = useCC(); const { t, i18n } = useTranslation('translation');
  const presence = useRef(null);
  const legendKey = cc.active && cc.snapshot ? cc.legendKey || JSON.stringify([cc.accessKey, cc.snapshot.snapshot_id, cc.scope]) : null;
  const regionCodes = cc.stats.data?.unfiltered_present_class_codes || cc.stats.data?.present_class_codes;
  if (!legendKey) presence.current = null;
  else if (regionCodes) presence.current = { key: legendKey, codes: regionCodes };
  if (!cc.active || !cc.snapshot) return null;
  const preview = isMapPreview(cc.snapshot);
  const legendScope = preview ? 'dataset' : cc.legendScope;
  const codes = legendScope === 'dataset' ? cc.snapshot.present_class_codes : presence.current?.key === legendKey ? presence.current.codes : [];
  return <div className="cc-legend">
    <Radio.Group size="small" value={legendScope} onChange={(e) => cc.setLegendScope(e.target.value)}
      options={[{ value: 'dataset', label: t('ci.datasetLegend') }, { value: 'region', label: t('ci.regionLegend'), disabled: preview }]} />
    {preview && <p className="ci-muted">{t('ci.previewLegendHelp')}</p>}
    <p className="ci-muted">{t(cc.exclusionsEnabled ? 'ci.legendToggleHelp' : 'ci.legendToggleUnavailable')}</p>
    {!!cc.excludedClassKeys?.length && <Button size="small" type="link" onClick={cc.clearCropExclusions}>{t('ci.showAllCrops')}</Button>}
    <div className="cc-legend-items">{cc.snapshot.classes.filter((entry) => codes.includes(entry.code))
      .sort((a, b) => (a.display_order || 0) - (b.display_order || 0)).map((entry) => <button key={entry.code} type="button"
        className="ci-legend-toggle" aria-pressed={!cc.excludedClassKeys?.includes(entry.semantic_key)}
        disabled={!cc.exclusionsEnabled} onClick={() => cc.toggleCropExclusion(entry.code)}>
        <i style={{ backgroundColor: entry.fill, borderColor: entry.stroke }} />{cropLabel(entry, t, i18n.language)}
        {!entry.is_crop && ` (${t('ci.background')})`}</button>)}
      {!codes.length && <span>{t(cc.stats.status === 'loading' ? 'cc.loading' : 'ci.legendUnavailable')}</span>}
    </div>
  </div>;
}
